import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from "@lingui/core";

var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  var _a;
  let value;
  switch ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname == null ? void 0 : hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg, daMsg, svMsg) => {
  if (locale === "nb") return nbMsg;
  if (locale === "fi") return fiMsg;
  if (locale === "da") return daMsg;
  if (locale === "sv") return svMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages, daMessages, svMessages) => {
  const locale = detectLocale();
  const messages = getMessages(locale, enMessages, nbMessages, fiMessages, daMessages, svMessages);
  i18n.load(locale, messages);
  i18n.activate(locale);
};

var msgs = { "nb": { "icon.title.tools": ["Verkt\xF8y"] }, "en": { "icon.title.tools": ["Tools"] }, "fi": { "icon.title.tools": ["Ty\xF6kalut"] }, "da": { "icon.title.tools": ["V\xE6rkt\xF8j"] }, "sv": { "icon.title.tools": ["Verktyg"] } };
activateI18n(msgs.en, msgs.nb, msgs.fi, msgs.da, msgs.sv);
var IconTools42 = class extends LitElement {
  render() {
    const title = i18n.t({ message: `Tools`, id: "icon.title.tools", comment: "Title for tools icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m17 12.29-1.136-1.13a4.921 4.921 0 0 1-6.572-6.553l1.544 1.54A1.64 1.64 0 1 0 13.16 3.83l-1.543-1.539a4.92 4.92 0 0 1 6.567 6.551l1.051 1.048m5.361 5.34 1.54 1.537a4.92 4.92 0 0 1 6.572 6.55l-1.544-1.539a1.64 1.64 0 0 0-2.323 2.317l1.543 1.538a4.921 4.921 0 0 1-6.567-6.55l-1.54-1.536M9.566 25.483a2.42 2.42 0 0 1 0-3.43l5.086-5.077a.81.81 0 0 1 1.147 0l2.294 2.287a.81.81 0 0 1 0 1.144l-5.087 5.076a2.44 2.44 0 0 1-3.44 0M25.968 2.287l6.74 6.717a1.613 1.613 0 0 1 0 2.287l-2.294 2.289a1.625 1.625 0 0 1-2.294 0l-6.74-6.717a1.614 1.614 0 0 1 0-2.287l2.294-2.287a1.625 1.625 0 0 1 2.294-.002m-1.147 8.005-7.983 7.72"></path></svg>`;
  }
};
if (!customElements.get("fp-icon-tools-42")) {
  customElements.define("fp-icon-tools-42", IconTools42);
}
export {
  IconTools42
};
